import { render } from "./expenses-report.vue?vue&type=template&id=4731665c"
import script from "./expenses-report.vue?vue&type=script&lang=js"
export * from "./expenses-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__